module.exports = __webpack_public_path__ + "static/media/thankyou-bg.3de535ea.png";